import { Avatar, Flex, FlexProps, Text } from "@chakra-ui/react";
import { useUser } from "../hooks/user.hooks";
import { useNavigate } from "react-router-dom";

function InlineUserAvatar({ id, logo, w = '40px', h = '40px', size = 'sm', link = false}: { id: number | string | undefined, logo?: boolean, link?: boolean, size?: string } & Pick<FlexProps, 'w' | 'h'>) {
  const { data: user } = useUser(id);
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(`/contacts/users/${id}`)
    }
  }
  if (!user) {
    return <>---</>
  }
  return (
    <Flex onClick={handleClick}>
      {(logo === undefined || logo === true) && <Avatar
        name={`${user.firstName} ${user.lastName}`}
        src="https://bit.ly/avatar"
        h={h}
        w={w}
        size={size}
        mr="10px"
      />}
      <Text
        lineHeight={w}
        fontWeight="500"
        size="12px"
        textTransform="capitalize"
        color={link ? "brand.700" : undefined}
        textDecoration={link ? "underline" : undefined}
      >
        {user.firstName} {user.lastName}
      </Text>
    </Flex>
  );
}

export default InlineUserAvatar;
